var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnischOntwerp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 88,
    viewBox: "0 0 87 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.75 4.2969V81.5C84.75 82.4946 84.3549 83.4484 83.6516 84.1517C82.9484 84.8549 81.9945 85.25 81 85.25H3.79686C3.05275 85.2624 2.32219 85.0503 1.70041 84.6413C1.07864 84.2323 0.594512 83.6455 0.311154 82.9574C0.0277964 82.2692 -0.0416435 81.5117 0.111888 80.7834C0.265419 80.0552 0.634797 79.3902 1.17186 78.875L78.3281 1.6719C78.8499 1.14209 79.5174 0.779354 80.2458 0.629796C80.9741 0.480237 81.7306 0.550606 82.4189 0.831959C83.1072 1.11331 83.6963 1.59295 84.1114 2.20991C84.5265 2.82687 84.7487 3.55331 84.75 4.2969Z",
    fill: "#FDC100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.75L85.5 86.25",
    stroke: "#445C7A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnischOntwerp);
export default __webpack_public_path__ + "static/media/technisch-ontwerp.ebf376dd6da3965e8abcf69fc50c7592.svg";
export { ForwardRef as ReactComponent };